import { tracked } from "@glimmer/tracking";
import Controller from "@ember/controller";
import { action } from "@ember/object";
import { trackedArray } from "@ember/reactive/collections";
import { service } from "@ember/service";
import { ajax } from "discourse/lib/ajax";
import { popupAjaxError } from "discourse/lib/ajax-error";
import {
  addUniqueValuesToArray,
  removeValueFromArray,
} from "discourse/lib/array-tools";
import EditCategoryGroup from "../../components/edit-category-group";

export default class AdminPluginsFlexibleRateLimitsController extends Controller {
  @service modal;
  @service router;

  @tracked availableCategoryIds = trackedArray();
  @tracked disableSave = false;

  @action
  addCategoryGroup() {
    this.modal.show(EditCategoryGroup, {
      model: { categoryGroups: this.model.category_groups },
    });
  }

  @action
  editCategoryGroup(categoryGroup) {
    this.modal.show(EditCategoryGroup, {
      model: { categoryGroups: this.model.category_groups, categoryGroup },
    });
  }

  @action
  deleteCategoryGroup(categoryGroup) {
    removeValueFromArray(this.model.category_groups, categoryGroup);
    addUniqueValuesToArray(
      this.availableCategoryIds,
      Array.from(categoryGroup.categories)
    );
  }

  @action
  async saveCategoryGroups() {
    if (!this.model.category_groups) {
      return;
    }

    this.disableSave = true;

    try {
      await ajax("/admin/plugins/flexible-rate-limits/save.json", {
        type: "POST",
        dataType: "json",
        contentType: "application/json",
        data: JSON.stringify({ category_groups: this.model.category_groups }),
      });
      this.reload();
    } catch (e) {
      popupAjaxError(e);
    } finally {
      this.disableSave = false;
    }
  }

  @action
  reload() {
    this.router.refresh("adminPlugins.flexible-rate-limits");
  }
}
